import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import Modal from '@mui/material/Modal';
import { buttonCss, popUpsCss } from '@digital_monorepo/styling';
import useRedux from '@/hooks/useRedux';

const SessionTimeoutModal = ({ timeout, logout }) => {
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState('');
  const { extendSession } = useRedux();

  // Function to extend session
  const handleExtendSession = useCallback(async () => {
    try {
      const result = await extendSession();
      if (result && result.success) {
        setShowModal(false);
      } else {
        console.error('Failed to extend session');
        logout();
      }
    } catch (error) {
      console.error('Failed to extend session:', error);
      logout();
    }
  }, [extendSession, logout]);

  // Monitor session timeout
  useEffect(() => {
    if (!timeout) return;
    
    const checkTimeRemaining = () => {
      const now = new Date().getTime();
      const expireTime = new Date(timeout).getTime();
      const remaining = expireTime - now;
      
      // Format countdown as mm:ss
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      setCountdown(`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
      
      // Show modal when less than 5 minutes remaining
      if (remaining > 0 && remaining < 5 * 60 * 1000) {
        setShowModal(true);
      } else if (remaining <= 0) {
        // Session expired, log out user
        setShowModal(false);
        logout();
      }
    };

    // Check every second
    const intervalId = setInterval(checkTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [timeout, logout]);

  return (
    <Modal 
      open={showModal} 
      onClose={() => {}} // Prevent closing by clicking outside
    >
      <div className={popUpsCss.modalContainer}>
        <div className={popUpsCss.modalHeader}>Session Timeout Warning</div>
        <div className={popUpsCss.modalBody}>
          <div>Your session will expire in:</div>
          <div style={{ fontSize: '24px', textAlign: 'center', margin: '15px 0' }}>{countdown}</div>
          <div>Would you like to extend your session?</div>
        </div>
        <div className={popUpsCss.modalFooter}>
          <button 
            className={cn(buttonCss.secondaryBtn, buttonCss.medium)} 
            onClick={logout}
          >
            Logout Now
          </button>
          <button 
            className={cn(buttonCss.primaryBtn, buttonCss.medium)} 
            onClick={handleExtendSession}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionTimeoutModal;
